<template>
  <div>
    <div class="layout documents-report">
      <div class="layout-header">
        <div class="layout-title">Отчет по документам</div>
        <div class="layout-header-actions">
          <div class="layout-header-action">
            <c-button
              size="small"
              :icon="{
                icon: 'bookmark',
                activeColor: 'white',
              }"
              :tooltip="{
                text: 'Добавить в закладки',
                activeText: 'Убрать из закладок',
              }"
              active-color="blue"
              :active="bookmark"
              @click="bookmark = !bookmark"
            />
          </div>
          <div class="layout-header-action">
            <google-form ref="googleForm"> </google-form>
          </div>
        </div>
      </div>

      <documents-report-filters ref="filters" @inited="onFiltersInit" @apply="applyFilters" />

      <documents-report-table ref="table" :inited="inited" :loading="loading" :workers="workers" @nextPage="nextPage" />
    </div>

    <top-button root=".layout"></top-button>
  </div>
</template>

<script>
import TopButton from "@/components/top-button";
import Button from "@/components/controls2/Button";

import DocumentsReportFilters from "./components/filters";
import DocumentsReportTable from "./components/table";
import GoogleForm from "./components/google-form";

import {createWorkerDocuments, WorkerDocuments} from '@/entities/models/worker-documents';

export default {
  name: "documents-report",

  components: {
    "c-button": Button,
    TopButton,

    DocumentsReportFilters,
    DocumentsReportTable,
    GoogleForm,
  },

  data() {
    return {
      bookmark: false,
      inited: false,
      page: 1,
      loading: false,
      lastRequestIsEmpty: false,
      workers: [],
    };
  },

  methods: {
    getParams() {
      const filters = this.$refs.filters.getParams();
      return {
        filters,
        page: this.page,
      };
    },

    loadData() {
      if (this.loading) return;
      if (this.lastRequestIsEmpty) return;

      this.loading = true;
      const params = this.getParams();
      this.$refs.googleForm.update(params);

      this.$store.dispatch("documentsReport/loadDocuments", params).then((res) => {
        const workers = res.response.map((doc) => createWorkerDocuments(doc));
        if (!workers.length) this.lastRequestIsEmpty = true;
        this.workers = [...this.workers, ...workers];
        this.loading = false;
        this.inited = true;
      });
    },

    onFiltersInit() {
      this.loadData();
    },

    applyFilters() {
      this.workers = [];
      this.loading = false;
      this.page = 1;
      this.lastRequestIsEmpty = false;
      this.loadData();
    },

    nextPage() {
      if (!this.inited) return;
      if (this.loading) return;
      this.page += 1;
      this.loadData();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

@include mobileAndTablet {
  .documents-report {
    padding-bottom: 84px;
  }
}

@include onlyStandartMobile {
  .documents-report {
    padding-bottom: 20px;
  }
  .documents-report-table {
    margin-left: -21px;
    margin-right: -21px;
    margin-top: 10px;
    padding-bottom: 12px;
  }
  .layout-header {
    margin-bottom: 24px;
    height: auto;
  }

  @include onlyMobile {
    .layout-header {
      align-items: center;
    }
  }
}
</style>
